module.exports = __webpack_public_path__ + "img/registro-visitas-semanal.ed3acc73.svg";